import { useRef } from 'react';
import styled from 'styled-components';
import { useTabsKeyboardNavigation } from '../../../../../helpers';
import { useData } from '../../main-layouts';
import { SectionsControlItem } from './SectionsControlItem';

export function SectionsControl() {
  const { visibleSections, selectedSection, setSelectedSection } = useData();
  const containerRef = useRef(null);

  const { tabsRef, handleKeyDown } = useTabsKeyboardNavigation(
    visibleSections,
    setSelectedSection
  );

  return (
    <>
      {visibleSections?.length > 1 && (
        <Container ref={containerRef}>
          <Component>
            {visibleSections.map(
              (item, index) =>
                item.id && (
                  <StyledSectionsItem
                    ref={(el) => (tabsRef.current[index] = el)}
                    data={item}
                    key={item.id}
                    selected={item.id === selectedSection?.id}
                    onClick={() => setSelectedSection(item)}
                    onKeyDown={(e) => handleKeyDown(e, index, item)}
                  />
                )
            )}
          </Component>
        </Container>
      )}
    </>
  );
}

const Container = styled.div``;

const Component = styled.div`
  display: flex;
  margin-bottom: 42px;
  justify-content: center;
  flex-wrap: wrap;
`;

const StyledSectionsItem = styled(SectionsControlItem)`
  margin: 6px 12px;
`;
